import { css } from 'linaria';
import fonts from 'style/fonts';
export const work = "w1xr0ox";
export const header = "h14jvkb6";
export const background = "blxi8ib";
export const gradient = "gcy2uyk";
export const titles = "tkvzo1y";
export const videoTitle = "vyswaqr";
export const project = "pdkonum";
export const title = "tnp0o78";
export const content = "cq1lxc";
export const videos = "v187qhpk";
export const current = "c1a6svoh";
export const gallery = "g1vce4j9";
export const thumb = "tmaqhzm";
export const nav = "nq18aj1";
export const navItem = "nlzxt93";

require("/Users/florianmorel/Work/Websites/rudy-vermorel-2019/.linaria-cache/src/components/work/styles.linaria.css");